import React from "react";
import { cn } from "@/lib/utils";

const WORDMARK = "/brand/gostops-logo.png";
const ICON = "/brand/gostops-icon.jpeg";

/**
 * goSTOPS brand marks.
 * Usage rules (design_guidelines.md):
 *  - Wordmark on desktop at 28-32px height, always on a solid surface.
 *  - Square icon on mobile / collapsed nav, wrapped in a 1px border tile.
 */
export const BrandWordmark = ({ className }) => (
  <img
    src={WORDMARK}
    alt="goSTOPS"
    className={cn("h-8 w-auto select-none", className)}
    draggable={false}
    data-testid="brand-wordmark"
  />
);

export const BrandIcon = ({ className, size = "h-9 w-9" }) => (
  <span
    className={cn(
      "flex shrink-0 items-center justify-center overflow-hidden rounded-xl border border-border bg-card",
      size,
      className
    )}
    data-testid="brand-icon"
  >
    <img src={ICON} alt="goSTOPS" className="h-full w-full object-cover" draggable={false} />
  </span>
);

/** Decorative 6-colour goSTOPS stripe. Never interactive, never behind text. */
export const BrandStripe = ({ className }) => (
  <div className={cn("vde-brand-stripe w-full", className)} aria-hidden="true" data-testid="brand-stripe" />
);
